<template>
  <!-- SEÇÃO: INSCRIÇÃO -->
  <section id="inscricao" class="bg-white mt-10 mb-10 rounded-lg">
    <div class="py-2 mx-auto max-w-screen-xl">
      <!-- Follow-up Form (quando há token na URL) -->
      <FollowUpForm v-if="followUpToken" />
      <!-- Contagem regressiva (inscrições ainda não abriram) -->
      <RegistrationCountdown
        v-else-if="beforeOpen"
        :opens-at="registrationOpensAt"
        @opened="beforeOpen = false"
      />
      <!-- Form padrão de inscrição -->
      <RSVPForm v-else />
    </div>
  </section>
</template>

<script>
import { computed, ref, onMounted, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useLandingPage } from '@/composables/useLandingPage'
import RSVPForm from '@/components/dynamic-form/RSVPForm.vue'
import FollowUpForm from '@/components/dynamic-form/FollowUpForm.vue'
import RegistrationCountdown from '@/components/dynamic-form/RegistrationCountdown.vue'

export default {
  name: 'RegisterSection',
  components: {
    RSVPForm,
    FollowUpForm,
    RegistrationCountdown
  },
  setup () {
    const route = useRoute()
    const { settings } = useLandingPage()

    const followUpToken = computed(() => {
      return route.params.token || route.query['acao-retorno'] || null
    })

    // Data de abertura das inscrições (opcional)
    const registrationOpensAt = computed(() => settings.value?.registration_opens_at || null)

    // Converte a data para timestamp (formato MySQL "YYYY-MM-DD HH:mm:ss" -> local)
    const opensAtTs = computed(() => {
      if (!registrationOpensAt.value) return null
      const t = new Date(String(registrationOpensAt.value).replace(' ', 'T')).getTime()
      return isNaN(t) ? null : t
    })

    // beforeOpen: true enquanto a data de abertura ainda está no futuro.
    // O componente de countdown emite 'opened' quando o tempo chega -> vira false.
    const beforeOpen = ref(false)

    const evaluateOpen = () => {
      beforeOpen.value = !!(opensAtTs.value && Date.now() < opensAtTs.value)
    }

    // Reavalia quando as settings carregam (fetch assíncrono)
    watch(opensAtTs, evaluateOpen, { immediate: true })

    // Auto-scroll para a seção de inscrição quando é follow-up
    const scrollToForm = async () => {
      if (followUpToken.value) {
        await nextTick()
        setTimeout(() => {
          const el = document.getElementById('inscricao')
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 500)
      }
    }

    onMounted(() => {
      scrollToForm()
    })

    watch(followUpToken, () => {
      scrollToForm()
    })

    return {
      followUpToken,
      registrationOpensAt,
      beforeOpen
    }
  }
}
</script>
